/** @jsxImportSource @emotion/react */
import { Box, Button, css, Theme, Typography } from '@mui/material'
import { theme } from '@app/styles/theme'
import {
  content,
  descriptionText,
  mainText,
  MobileBodyText,
  MobileHeaderText,
  propertyLogoStyle,
  RexContainerLeftInnerContainer,
  ShowOnMobile,
} from './FeatureCallToAction.style'

const FeatureCallToAction = ({
  heading,
  description,
  logo,
}: {
  heading?: string
  description?: string
  logo?: string
}) => {
  return (
    <Box component="main" css={content}>
      <Box css={ShowOnMobile}>
        <Box component="main" css={RexContainerLeftInnerContainer}>
          <Typography variant="h2" css={MobileHeaderText({ theme })}>
            {heading}
          </Typography>
          <Typography variant="body1" css={MobileBodyText({ theme })}>
            {description}
          </Typography>
        </Box>
      </Box>

      <Box
        component={'img'}
        src={logo}
        css={propertyLogoStyle}
        alt="Property - Resilience Explorer"
      />

      <Typography variant="h4" css={mainText({ theme })}>
        {heading}
      </Typography>
      <Typography variant="h4" css={descriptionText({ theme })}>
        {description}
      </Typography>

      <a
        href="https://resilience-explorer.org/contact-resilience-explorer/"
        target="_blank"
        rel="noreferrer"
      >
        <Button variant="contained" color="blue">
          Find out more
        </Button>
      </a>

      <Box></Box>
    </Box>
  )
}

export default FeatureCallToAction

export const secondaryTextText = ({ theme }: { theme: Theme }) => css`
  color: ${theme.palette.white.main};
  font-weight: 300;
  margin-top: 80px;
  display: flex;

  @media (max-width: 1410px) {
    font-size: 1rem;
  }

  @media (max-width: 460px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a {
    color: ${theme.palette.white.main};
    text-decoration: underline;
    text-underline-offset: ${theme.spacing(1)};
    margin-left: ${theme.spacing(2)};
  }
`
